export default __webpack_public_path__ + "static/media/10AW2FEB66.1c9288af.jpg";